import {Injectable} from '@angular/core';
import {HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable()
export class BaseUrl implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): any {
        if (/^(https?:)?\/\//.test(req.url) || req.url.startsWith('/assets/') || req.url.startsWith('assets/')) {
            return next.handle(req);
        }

        const baseUrl = environment.API_ENDPOINT;
        const apiRequest = req.clone({url: baseUrl + req.url});
        return next.handle(apiRequest);
    }
}
